import React from 'react';
import Container from 'react-bootstrap/Container';

function Dashboard() {
  return (
    <>
      {/* Page Header */}
      <section style={{ 
        background: '#ffffff', 
        borderBottom: '1px solid #e9ecef', 
        padding: '1.5rem 0',
        marginBottom: '2rem',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
      }}>
        <Container>
          <h2 style={{ 
            color: '#2c3e50', 
            fontFamily: 'system-ui, -apple-system, sans-serif', 
            fontWeight: 600, 
            fontSize: '1.75rem',
            margin: 0
          }}>
            Dashboard
          </h2>
        </Container>
      </section>

      {/* Blank Dashboard Content */}
      <section style={{ padding: '0 1rem' }}>
        <Container>
          <div style={{ 
            background: '#ffffff',
            borderRadius: '8px',
            padding: '3rem',
            textAlign: 'center',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            border: '1px solid #e9ecef'
          }}>
            <div style={{ fontSize: '4rem', marginBottom: '1.5rem' }}>🎯</div>
            <h3 style={{ 
              color: '#2c3e50', 
              fontFamily: 'system-ui, -apple-system, sans-serif', 
              fontWeight: 600,
              marginBottom: '1rem',
              fontSize: '1.5rem'
            }}>
              Welcome to Your Dashboard
            </h3>
            <p style={{ 
              color: '#6c757d', 
              fontSize: '1.1rem',
              marginBottom: '2rem',
              lineHeight: '1.6'
            }}>
              This is a simplified dashboard with only login/logoff functionality.
            </p>
            <div style={{ 
              padding: '2rem', 
              border: '2px dashed #dee2e6', 
              borderRadius: '8px',
              background: '#f8f9fa',
              maxWidth: '500px',
              margin: '0 auto'
            }}>
              <p style={{ 
                color: '#6c757d', 
                fontSize: '1rem',
                margin: 0,
                fontStyle: 'italic'
              }}>
                Dashboard content area - ready for future features
              </p>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
}

export default Dashboard; 